import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
import _imports_0 from '../../../../public/images/invoice123White.svg';
const _hoisted_1 = { class: "onboarding-guide__container" };
const _hoisted_2 = { class: "onboarding-guide__banner" };
const _hoisted_3 = { class: "v2-text--base-2 text-white" };
const _hoisted_4 = { class: "onboarding-guide__content" };
const _hoisted_5 = { class: "onboarding-guide__progress-container" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "onboarding-guide__settings" };
const _hoisted_8 = { class: "onboarding-guide__settings-title-container" };
const _hoisted_9 = { class: "v2-title--medium-2" };
const _hoisted_10 = { class: "v2-text--small text-v2-secondary" };
const _hoisted_11 = { class: "onboarding-guide__settings-container" };
const _hoisted_12 = {
    key: 0,
    class: "m-0"
};
const _hoisted_13 = { class: "mt-auto" };
const _hoisted_14 = { class: "d-flex" };
import { computed, reactive, ref, watch } from 'vue';
import ButtonV2 from '@/components/button/button-v2.vue';
import Setting from '@/modals/personalization-guide/partials/setting.vue';
import { useHttpAdapter } from '@/composables/http/http-adapter';
import { httpService, routerService, toastService } from '@/core';
import { onboardingGuideEditUrl } from '@/api/onboarding/onboarding';
import Finish from '@/modals/personalization-guide/partials/finish.vue';
import { amplitudeService } from '@/models/amplitude-service.ts';
export default /*@__PURE__*/ _defineComponent(Object.assign({
    name: 'PersonalizationGuide',
}, { __name: 'manage', props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    }, emits: ['update:modelValue'], setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const value = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        const tabIndex = ref(1);
        const availableTabs = ref([]);
        const completedCategories = ref([]);
        const hasNext = computed(() => tabIndex.value < tabCount.value);
        const tabCount = computed(() => availableTabs.value.length + 1);
        const hasPrevious = computed(() => tabIndex.value > 1);
        const adapter = useHttpAdapter(makeLoadRequest, loaded, onError);
        const guideConfig = reactive({});
        const emailTemplateExists = ref(false);
        watch(() => props.modelValue, (newValue) => {
            if (newValue) {
                adapter.execute();
            }
        });
        function makeLoadRequest() {
            return httpService.get(onboardingGuideEditUrl());
        }
        function loaded(response) {
            var _a;
            Object.assign(guideConfig, response.data.data.guide_config);
            completedCategories.value = response.data.data.completed_categories || [];
            emailTemplateExists.value = response.data.data.email_template_exists;
            availableTabs.value = response.data.data.tabs || [];
            const categoriesObject = Object.fromEntries(Object.values(guideConfig['categories'] || {}).map((category) => {
                const cat = category;
                return [cat.id, { completed: cat.completed }];
            }));
            amplitudeService.trackEvent('[Frontend] User Viewed Personalization Guide', {
                config: categoriesObject,
                categoriesIds: Object.keys(categoriesObject),
            });
            trackTabChangeEvent('Open Modal', tabIndex.value - 1, (_a = availableTabs.value[tabIndex.value - 1]) === null || _a === void 0 ? void 0 : _a.categories);
        }
        function onError(error) {
            toastService.fromResponse(error);
        }
        function goBack() {
            var _a;
            tabIndex.value = tabIndex.value - 1;
            trackTabChangeEvent('Back', tabIndex.value - 1, (_a = availableTabs.value[tabIndex.value - 1]) === null || _a === void 0 ? void 0 : _a.categories);
        }
        function goNext() {
            var _a;
            tabIndex.value = tabIndex.value + 1;
            trackTabChangeEvent('Next', tabIndex.value - 1, (_a = availableTabs.value[tabIndex.value - 1]) === null || _a === void 0 ? void 0 : _a.categories);
        }
        function finishOnboarding() {
            value.value = false;
        }
        function goToSettings(category) {
            trackButtonClick('Go to Settings', tabIndex.value - 1, category);
            switch (category) {
                case 'series':
                    routerService.push({ name: 'company.edit', params: { tab: 'series' } });
                    break;
                case 'bank_details':
                    routerService.push({ name: 'company.edit', params: { tab: 'banks' } });
                    break;
                case 'vat':
                    routerService.push({ name: 'company.edit', params: { tab: 'vats' } });
                    break;
                case 'logo':
                    routerService.push({ name: 'company.edit', params: { tab: 'logotypes' } });
                    break;
                case 'template':
                    routerService.push({ name: 'template.index' });
                    break;
                case 'email_template':
                    // cant create another template if one already exists
                    if (emailTemplateExists.value) {
                        routerService.push({ name: 'company.edit', params: { tab: 'invoices' } });
                    }
                    else {
                        routerService.push({ name: 'email-templates.create' });
                    }
                    break;
                case 'smtp':
                    routerService.push({ name: 'module.edit', params: { id: 'smtp' } });
                    break;
                case 'payment_reminders':
                    routerService.push({ name: 'module.edit', params: { id: 'invoice_email_reminder' } });
                    break;
                case 'rivile':
                    routerService.push({ name: 'module.edit', params: { id: 'rivile' } });
                    break;
                case 'rivile_erp':
                    routerService.push({ name: 'module.edit', params: { id: 'rivile-erp' } });
                    break;
                case 'finvalda':
                    routerService.push({ name: 'module.edit', params: { id: 'finvalda' } });
                    break;
                case 'apsa':
                    routerService.push({ name: 'module.edit', params: { id: 'apsa' } });
                    break;
                case 'debeta':
                    routerService.push({ name: 'module.edit', params: { id: 'debeta' } });
                    break;
                case 'optimum':
                    routerService.push({ name: 'module.edit', params: { id: 'optimum' } });
                    break;
                case 'lobasoft':
                    routerService.push({ name: 'module.edit', params: { id: 'lobasoft' } });
                    break;
                case 'butenta':
                    routerService.push({ name: 'module.edit', params: { id: 'butenta' } });
                    break;
                case 'sabis':
                    routerService.push({ name: 'module.edit', params: { id: 'sabis' } });
                    break;
                case 'agnum':
                    routerService.push({ name: 'module.edit', params: { id: 'agnum' } });
                    break;
                case 'woocommerce':
                    routerService.push({ name: 'module.edit', params: { id: 'woocommerce' } });
                    break;
                case 'shopify':
                    routerService.push({ name: 'module.edit', params: { id: 'shopify' } });
                    break;
                case 'verskis':
                    routerService.push({ name: 'module.edit', params: { id: 'verskis' } });
                    break;
                case 'prestashop':
                    routerService.push({ name: 'module.edit', params: { id: 'prestashop' } });
                    break;
                case 'ovoko':
                    routerService.push({ name: 'module.edit', params: { id: 'ovoko' } });
                    break;
                case 'sip':
                    routerService.push({ name: 'module.edit', params: { id: 'sip' } });
                    break;
                case 'eskola':
                    routerService.push({ name: 'module.edit', params: { id: 'eskola' } });
                    break;
                case 'warehouse':
                    routerService.push({ name: 'module.edit', params: { id: 'warehouse' } });
                    break;
            }
            value.value = false;
        }
        function closeGuide() {
            value.value = false;
            trackButtonClick('Close Modal', tabIndex.value - 1);
        }
        function settingsExpanded(value, categoryId) {
            if (value) {
                trackButtonClick('Expand Setting', tabIndex.value - 1, categoryId);
            }
        }
        function changeTab(index) {
            var _a;
            tabIndex.value = index + 1;
            trackTabChangeEvent('Change Tab', tabIndex.value - 1, (_a = availableTabs.value[tabIndex.value - 1]) === null || _a === void 0 ? void 0 : _a.categories);
        }
        function buildCategoriesObject(categories = []) {
            return Object.fromEntries(categories.map((category) => [category.id, { completed: category.completed }]));
        }
        function isTabCompleted(index) {
            var _a;
            if (tabIndex.value === index + 1) {
                return false;
            }
            const tabs = availableTabs.value[index];
            return (_a = tabs === null || tabs === void 0 ? void 0 : tabs.categories) === null || _a === void 0 ? void 0 : _a.every(category => category.completed);
        }
        function trackTabChangeEvent(action, tabIdx, categories = []) {
            const categoriesObject = buildCategoriesObject(categories);
            amplitudeService.trackEvent('[Frontend] User Viewed Personalization Guide Tab', {
                action,
                tabIndex: tabIdx,
                categories: categoriesObject,
                categoriesIds: Object.keys(categoriesObject),
                allCategoriesCompleted: categories.every((c) => c.completed),
                lastTab: tabIdx + 1 === tabCount.value,
            });
        }
        function trackButtonClick(button, tabIndex, category) {
            amplitudeService.trackEvent('[Frontend] User Clicked Button', {
                button: button,
                page: 'Personalization Guide',
                pageType: 'Personalization',
                additionalProperties: {
                    tabIndex: tabIndex,
                    category: category ? category : null,
                },
            });
        }
        return (_ctx, _cache) => {
            const _component_s_loader = _resolveComponent("s-loader");
            const _component_s_modal = _resolveComponent("s-modal");
            return (_openBlock(), _createBlock(_component_s_modal, {
                onClose: closeGuide,
                class: "onboarding-guide__modal",
                "model-value": value.value,
                "modal-class": ['v2-modal']
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[0] || (_cache[0] = _createElementVNode("img", {
                                style: { "width": "127px" },
                                src: _imports_0,
                                alt: "logo"
                            }, null, -1)),
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "flex-1" }, null, -1)),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('onboarding-guide.slogan')), 1)
                        ]),
                        _createVNode(_component_s_loader, {
                            class: "w-100",
                            value: _unref(adapter).busy.value
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabCount.value, (tab, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                onClick: ($event) => (changeTab(index)),
                                                class: _normalizeClass(["onboarding-guide__progress-container-bubble v2-text--tiny-2", { 'onboarding-guide__progress-container-bubble--active': tabIndex.value === index + 1,
                                                        'onboarding-guide__progress-container-bubble--completed': isTabCompleted(index)
                                                    }])
                                            }, _toDisplayString(index + 1), 11, _hoisted_6));
                                        }), 256))
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTabs.value, (tab, index) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: tab.id
                                        }, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", _hoisted_8, [
                                                    _createElementVNode("div", _hoisted_9, _toDisplayString(tab.title), 1),
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(tab.description), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_11, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.categories, (category, categoryIndex) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                                            key: category.id
                                                        }, [
                                                            _createVNode(Setting, {
                                                                "is-completed": category.completed,
                                                                title: category.title,
                                                                onExpandChange: ($event) => (settingsExpanded($event, category.id))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(category.description) + " ", 1),
                                                                    _createVNode(ButtonV2, {
                                                                        onClick: ($event) => (goToSettings(category.id)),
                                                                        style: { "margin-top": "8px" },
                                                                        size: "small",
                                                                        theme: "primary"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('actions.please_set')), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["onClick"])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["is-completed", "title", "onExpandChange"]),
                                                            (categoryIndex < tab.categories.length - 1)
                                                                ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
                                                                : _createCommentVNode("", true)
                                                        ], 64));
                                                    }), 128))
                                                ])
                                            ])
                                        ])), [
                                            [_vShow, tabIndex.value === index + 1]
                                        ]);
                                    }), 128)),
                                    (!hasNext.value)
                                        ? (_openBlock(), _createBlock(Finish, {
                                            key: 0,
                                            tabs: availableTabs.value
                                        }, null, 8, ["tabs"]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            (hasPrevious.value)
                                                ? (_openBlock(), _createBlock(ButtonV2, {
                                                    key: 0,
                                                    onClick: goBack,
                                                    theme: "ghost"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('actions.back')), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (hasNext.value)
                                                ? (_openBlock(), _createBlock(ButtonV2, {
                                                    key: 1,
                                                    onClick: goNext,
                                                    theme: "base",
                                                    class: "ml-auto"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('actions.next')), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (!hasNext.value)
                                                ? (_openBlock(), _createBlock(ButtonV2, {
                                                    key: 2,
                                                    onClick: finishOnboarding,
                                                    class: "ml-auto"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('onboarding-guide.actions.finish')), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["value"])
                    ])
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    } }));
